var map = {
  "./Star.svg": "./Resources/SVGs/Star.svg",
  "./arrow-down.svg": "./Resources/SVGs/arrow-down.svg",
  "./arrow-left.svg": "./Resources/SVGs/arrow-left.svg",
  "./arrow-right.svg": "./Resources/SVGs/arrow-right.svg",
  "./arrow-up.svg": "./Resources/SVGs/arrow-up.svg"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = "./Resources/SVGs sync recursive \\.svg$";
